import { inject } from 'vue'

export function useModal () {
  const $modal = inject('$modal')

  return {
    show: (name) => {
      if ($modal) {
        $modal.show(name)
      }
    },
    hide: (name) => {
      if ($modal) {
        $modal.hide(name)
      }
    }
  }
}
